import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const oilApi = axios.create({ baseURL: `${BACKEND_URL}/api/oil`, timeout: 30000 });

oilApi.interceptors.request.use((config) => {
  const t = localStorage.getItem('customer_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const genCmd = () =>
  (window.crypto?.randomUUID?.() || `cmd-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);

export const oilWsUrl = () =>
  `${BACKEND_URL.replace(/^http/, 'ws')}/api/oil/ws`;

export const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

export const REASONS = {
  insufficient_black: 'Black Coins insuficientes.',
  insufficient_drops: 'Gotas de petróleo insuficientes.',
  insufficient: 'Saldo insuficiente.',
  no_refinery: 'Você ainda não tem uma refinaria.',
  max_level: 'Nível máximo atingido.',
  max_shields: 'Limite de escudos atingido.',
  bottling_level: 'Sua envasadora não suporta este barril. Faça upgrade!',
  barrel_unavailable: 'Barril indisponível.',
  processing: 'Ação já em processamento...',
  target_daily_limit: 'Você já bateu o limite de golpes neste alvo hoje. Procure outro império.',
  daily_limit: 'Limite diário de operações ofensivas atingido.',
  conflict: 'Conflito — tente novamente.',
  invalid_level: 'Nível inválido.',
};

export const reasonMsg = (r) =>
  r?.message || REASONS[r?.reason] || 'Operação não concluída.';

export const BARREL_STYLE = {
  1: { emoji: '🛢️', label: 'Aço Negro', cls: 'from-zinc-700 to-zinc-900 border-zinc-500' },
  2: { emoji: '🛢️', label: 'Industrial', cls: 'from-emerald-800 to-emerald-950 border-emerald-500' },
  3: { emoji: '🛢️', label: 'Premium', cls: 'from-blue-800 to-blue-950 border-blue-400' },
  4: { emoji: '🛢️', label: 'Dourado', cls: 'from-amber-600 to-amber-900 border-amber-400' },
  5: { emoji: '🛢️', label: 'Lendário', cls: 'from-rose-700 to-amber-800 border-rose-400' },
};
